import data from "../../../_inc/parts/character/character_list.json" assert { type: "json" };
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class SwitchChara {
  constructor() {
    this.data = data;
    this.init();
  }

  init() {
    this._setMaru();
    this.clickChange();
  }

  _setMaru() {
    const charactercont = document.querySelector(".js-character");

    const id = 0;
    this._chengechara(id);
    this._isNav(id);

    setTimeout(() => {
      charactercont.classList.add("-charaIn");
    }, 500);
  }

  clickChange() {
    const switchbtn = document.querySelectorAll(".js-character-switch");

    [...switchbtn].forEach((el) => {
      el.addEventListener("click", () => {
        const charaId = el.getAttribute("data-charaid");
        this._setAnimation();
        this._chengechara(charaId);
        this._isNav(charaId);

        if (el.classList.contains("character__item__btn")) {
          this._setTop();
        }
      });
    });
  }

  _chengechara(charaId) {
    const charadata = this.data[charaId];
    const charactercont = document.querySelector(".js-character");

    const switchprev = document.querySelector(".js-character-switch.-prev");
    const switchnext = document.querySelector(".js-character-switch.-next");
    const name_m = document.querySelector(".js-character-ph.c-visible_makyou");
    const name_t = document.querySelector(".js-character-ph.c-visible_tengoku");
    const bgfill = document.querySelector(".js-character-fill");
    const bgline = document.querySelectorAll(".js-character-line");
    const txt = document.querySelector(".js-character-txt");
    const cv = document.querySelector(".js-character-cv");
    const ph = document.querySelector(".js-character-mainph");

    const setprev = charadata.prev;
    const setnext = charadata.next;
    const setname_id = charadata.id;
    const setposition = charadata.position;
    const setcv = charadata.cv;
    const settxt = charadata.caption;
    const setfill = charadata.name_fill;
    const setline = charadata.name_line;

    const phpath = `/assets/img/character/${setname_id}/ph_main.png`;
    const namephpath_m = `/assets/img/character/${setname_id}/name_ja_m.png`;
    const namephpath_t = `/assets/img/character/${setname_id}/name_ja_t.png`;

    //各初期化
    charactercont.setAttribute("data-chara", "");
    charactercont.setAttribute("data-position", "");
    switchprev.setAttribute("data-charaid", "");
    switchnext.setAttribute("data-charaid", "");
    ph.setAttribute("src", "");
    name_m.setAttribute("src", "");
    name_t.setAttribute("src", "");

    //各セット
    charactercont.setAttribute("data-chara", setname_id);
    charactercont.setAttribute("data-position", setposition);
    switchprev.setAttribute("data-charaid", setprev);
    switchnext.setAttribute("data-charaid", setnext);
    ph.setAttribute("src", phpath);
    name_m.setAttribute("src", namephpath_m);
    name_t.setAttribute("src", namephpath_t);
    bgfill.innerHTML = setfill;
    [...bgline].forEach((el) => {
      el.innerHTML = setline;
    });
    txt.innerHTML = settxt;
    cv.textContent = setcv;
  }

  _setAnimation() {
    const charactercont = document.querySelector(".js-character");
    const flag = charactercont.classList.contains("-charaIn");

    if (flag) {
      charactercont.classList.remove("-charaIn");

      setTimeout(() => {
        charactercont.classList.add("-charaIn");
      }, 100);
    }
  }

  _isNav(charaId) {
    const charadata = this.data[charaId];
    const nav = document.querySelectorAll(".character__nav__item");

    const setname_id = charadata.id;

    [...nav].forEach((el) => {
      el.classList.remove("-active");
      const flag = el.classList.contains(setname_id);

      if (flag) {
        el.classList.add("-active");
      }
    });
  }

  _setTop() {
    gsap.to(window, {
      duration: 0,
      scrollTo: { y: 0 },
      ease: "circ.inOut",
    });
  }
}
